import type { TFunction } from "i18next";

import { ApiError } from "../api.js";

/** Meldungen aus einem 422 `JIRA_VALIDATION` (Originaltexte von Jira), sonst null. */
export function jiraValidationMessages(err: unknown): string[] | null {
  if (!(err instanceof ApiError) || err.status !== 422 || err.code !== "JIRA_VALIDATION") return null;
  const d = err.details as { messages?: unknown } | undefined;
  const messages = Array.isArray(d?.messages) ? d.messages.filter((m): m is string => typeof m === "string") : [];
  return messages.length ? messages : [err.message];
}

/**
 * Anzeigetext für einen fehlgeschlagenen Schreibversuch (Item 7): Ein 422
 * `JIRA_VALIDATION` zeigt Jiras Originalmeldungen, ab Status 500 den Hinweis,
 * dass die Änderung Jira trotz Fehlerantwort erreicht haben könnte — Jira
 * übernimmt manchmal die Schreibung, bevor die Antwort mit einem Serverfehler
 * abbricht —, alles andere den aufrufer-spezifischen Fallback-Schlüssel
 * (z. B. `actions.saveFailed`/`actions.commentFailed`).
 */
export function writeErrorText(err: unknown, t: TFunction, fallbackKey: string): string {
  const messages = jiraValidationMessages(err);
  if (messages) return messages.join(" ");
  if (err instanceof ApiError && err.status >= 500) return t("pages.customerView.cockpit.actions.maybeSaved");
  return t(fallbackKey);
}
